// @flow

import * as atypes from "src/constants/actionTypes";
import {
  fileOperationErrors,
  workflowErrors,
  roomErrors,
} from "src/constants/errorMessages";

import type { Error, Action } from "src/types";

const initialState = {};

const error = (state: Error = initialState, { type, payload }: Action) => {
  switch (type) {
    case atypes.SET_ERROR:
      return {
        ...state,
        [payload.type]: payload.error,
      };
    case atypes.GET_PROFILE_FAILURE:
      return { ...state, profile: "Error in fetching failure" };
    case atypes.UPLOAD_PROFILE_PHOTO_FAILURE:
      return { ...state, profile: "Error in uploading profile photo" };
    case atypes.UPLOAD_PROFILE_PICTURE_FILE_FAILURE:
      return {
        ...state,
        profile: "Error in uploading in profile photo in firebase",
      };
    case atypes.LOAD_WORKFLOW_FAILURE:
      return {
        ...state,
        workflow: workflowErrors.LOAD_ERROR,
      };
    case atypes.CREATE_WORKFLOW_FAILURE:
      return {
        ...state,
        workflow: workflowErrors.CREATE_ERROR,
      };
    case atypes.CREATE_INLINE_WORKFLOW_FAILURE:
      return {
        ...state,
        inlineWorkflow: workflowErrors.DRAFT_CREATE_ERROR,
      };
    case atypes.EDIT_WORKFLOW_FAILURE:
      return {
        ...state,
        workflow: workflowErrors.EDIT_ERROR,
      };
    case atypes.SEARCH_USERS_FAILURE:
      return {
        ...state,
        searchUser: "Error in searching users",
      };
    case atypes.LISTEN_FILE_CHANGE_FAILURE:
      return {
        ...state,
        files: "Error in listening for file changes",
      };
    case atypes.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.UPLOAD_ERROR,
      };
    case atypes.DOWNLOAD_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.DOWNLOAD_ERROR,
      };
    case atypes.DELETE_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.DELETE_ERROR,
      };
    case atypes.RENAME_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.RENAME_ERROR,
      };
    case atypes.MOVE_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.MOVE_ERROR,
      };
    case atypes.CLONE_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.CLONE_ERROR,
      };
    case atypes.PIN_FILE_FAILURE:
      return {
        ...state,
        files: fileOperationErrors.PIN_ERROR,
      };
    case atypes.FETCH_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.FETCH_ERROR,
      };
    case atypes.CREATE_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.CREATE_ERROR,
      };
    case atypes.DELETE_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.DELETE_ERROR,
      };
    case atypes.RENAME_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.RENAME_ERROR,
      };
    case atypes.MOVE_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.MOVE_ERROR,
      };
    case atypes.FETCH_BROWSE_FOLDER_FAILURE:
      return {
        ...state,
        folder: fileOperationErrors.FETCH_ERROR,
      };
    case atypes.ADD_ROOM_MEMBER_REQUEST_FAILURE:
      return {
        ...state,
        member: roomErrors.MEMBER_ADD_ERROR,
      };
    case atypes.REMOVE_ROOM_MEMBER_REQUEST_FAILURE:
      return {
        ...state,
        member: roomErrors.MEMBER_REMOVE_ERROR,
      };
    case atypes.CLEAR_ERROR:
      return {
        ...state,
        [payload.type]: null,
      };
    case atypes.CREATE_CHATROOM_FAILURE:
      return {
        ...state,
        chatroom: roomErrors.CREATE_ERROR,
      };
    case atypes.INIT_USER_FAILURE:
      return {
        ...state,
        initUser: payload,
      };
    case atypes.OPEN_FILE_VIEWER_FAILURE:
      return {
        ...state,
        file: fileOperationErrors.VIEW_ERROR,
      };
    case atypes.CLEAR_ALL_ERRORS:
      return {};
    default:
      return state;
  }
};

export default error;
